export const REMOTE_JOBS_SYNC_PENDING_POLL_MS = 5_000;
export const REMOTE_JOBS_SYNC_PENDING_CAP_MS = 10 * 60 * 1000;

export function formatAtsJobLabel(
  title: string,
  remoteId: string,
  showIds: boolean,
): string {
  return showIds ? `${title} · ${remoteId}` : title;
}

export function isRemoteJobOpen(status: string): boolean {
  return (status ?? "").toUpperCase() === "OPEN";
}

export function isRemoteJobSelectable(
  status: string,
  alreadyLinked: boolean,
): boolean {
  return isRemoteJobOpen(status) && !alreadyLinked;
}

export function remoteJobClosedBadge(status: string): string | undefined {
  const s = status.toUpperCase();
  if (s === "OPEN") return undefined;
  if (s === "CLOSED") return "Closed";
  return "Not open";
}
